'use strict';

var _objectSpread = require("E:\\Code Bases\\Frontier\\Athena\\athena-trial\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/objectSpread2");

var _classCallCheck = require("E:\\Code Bases\\Frontier\\Athena\\athena-trial\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("E:\\Code Bases\\Frontier\\Athena\\athena-trial\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");

var _inherits = require("E:\\Code Bases\\Frontier\\Athena\\athena-trial\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/inherits");

var _createSuper = require("E:\\Code Bases\\Frontier\\Athena\\athena-trial\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createSuper");

var Node = require('./node');

var Declaration = /*#__PURE__*/function (_Node) {
  _inherits(Declaration, _Node);

  var _super = _createSuper(Declaration);

  function Declaration(defaults) {
    var _this;

    _classCallCheck(this, Declaration);

    if (defaults && typeof defaults.value !== 'undefined' && typeof defaults.value !== 'string') {
      defaults = _objectSpread(_objectSpread({}, defaults), {}, {
        value: String(defaults.value)
      });
    }

    _this = _super.call(this, defaults);
    _this.type = 'decl';
    return _this;
  }

  _createClass(Declaration, [{
    key: "variable",
    get: function get() {
      return this.prop.startsWith('--') || this.prop[0] === '$';
    }
  }]);

  return Declaration;
}(Node);

module.exports = Declaration;
Declaration.default = Declaration;